<template>
  <div>
    <div class="header-box" :style="{ background: background }" :class="navShow ? 'navOn' : 'navOff'">
      <div class="left-logo"  @click="logoLink" v-show="logoFalse">
        <img :src="logoImg" alt="">
      </div>
      <div class="left-logo" :style="'background-image: url(' + logoImgFalse + ')'" @click="logoLink"
        v-show="!logoFalse"></div>
      <!-- 导航菜单 -->
      <div class="content-nav" :class="{ 'content-ennaav': getLangData !== 'CN' }">
        <div :class="{ active: $route.path === item.path }" class="nav-item" v-for="(item, index) in tabHdear"
          :key="index" @mouseenter="handleMouseEnter(index)" @mouseleave="handleMouseLeaveone(index)">
          <span :style="{ color: color }" @click="changeRoute(item)" :class="{ 'jp-text': getLangData === 'JP' }">
            {{ item.name }}
          </span>
          <div class="nav-line" :style="{ background: backgroundLine }"></div>

          <!-- 业务下拉菜单 -->
          <div v-if="index === 1" class="vocationalShow" @mouseleave="handleMouseLeave(index)"
            v-show="vocationFalse === index">
            <nav-dropdown-item v-for="(it, idx) in vocatabList" :key="idx" :item="it" :background-line="backgroundLine"
              @click.native="vocatabClick(it, item)" />
          </div>
        </div>
      </div>
      <!-- 语言切换 -->
      <div class="right-search">
        <el-dropdown @command="changeLang" trigger="hover">
          <div class="language-box" :style="{ color: color }">
            <img src="../assets/home/language.png" :style="{ filter: imageFilter }" alt="" class="language-icon" />
            <span>{{ languageList.find(item => item.value === getLangData)?.label }}</span>
          </div>

          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="lang in languageList" :key="lang.value" :command="lang.value">{{ lang.label
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <router-view :nameScero="nameScero" :idData="idData" />
  </div>
</template>
<script>
import { getIndexData } from "@/api";
import NavDropdownItem from './NavDropdownItem.vue'
export default {
  components: {
    NavDropdownItem
  },
  data() {
    return {
      getLangData: localStorage.getItem("lang") || "CN",
      routerIndex: 0,
      tabHdear: [
        { name: this.$t("header.home"), path: "/secondLevel/HomeView", id: 0 },
        { name: this.$t("header.yewu"), path: "/secondLevel/vocationalView" },
        { name: this.$t("header.xiangmu"), path: "/secondLevel/projectView" },
        { name: this.$t("header.zhuanjia"), path: "/secondLevel/specialView" },
        { name: this.$t("header.xueyuan"), path: "https://www.mjvfx.com" },
        { name: this.$t("header.zhaopin"), path: "/secondLevel/recruitView" },
        { name: this.$t("header.xinwen"), path: "/secondLevel/newsView" },
        { name: this.$t("header.guanyu"), path: "/secondLevel/AboutView" },
        { name: this.$t("header.lianxi"), path: "/secondLevel/contactUs" },
      ],
      logoImg: require("../assets/home/headerLogo.png"),
      vocationFalse: null,
      background: "rgba(0,0,0,0)",
      color: "#fff",
      border: "1px solid rgba(255, 255, 255, 0.5)",
      logoImgFalse: require("../assets/home/footLogo.png"),
      logoFalse: true,
      topUp: "",
      navShow: true,
      backgroundLine: "#fff",
      colorNav: "#333",
      vocatabList: [
        { name: "游戏完整开发", idName: "kaifa" },
        { name: "2D游戏美术", idName: "youxi" },
        { name: "3D游戏美术", idName: "meishu" },
        { name: "游戏特效", idName: "texiao" },
        { name: "游戏动作", idName: "dongzuo" },
      ],
      nameScero: "",
      idData: 0,
      languageList: [
        {
          label: '简体中文',
          value: 'CN',
        },
        {
          label: 'English',
          value: 'EN',
        }, {
          label: '日本語',
          value: 'JP',
        }, {
          label: '한국어',
          value: 'KO',
        }],
      // backdropFilter: "saturate(180%) blur(0)",
    };
  },
  computed: {
    imageFilter() {
    return this.color === '#fff' ? 'brightness(0) invert(1)' : 'brightness(0)';
  }
  },
  created() {
    this.getIndexDataList();
  },
  mounted() {
    window.addEventListener("scroll", () => {
      this.topUp =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;
    });
    // let url = window.location.href.split("secondLevel/")[1];
    // console.log(window.location.href.split("secondLevel/")[1], 'qwqwwqwwqww');
    // let hhhhh = document.querySelectorAll('.nav-item')
    // console.log(hhhhh, 'jhhhhhhhhhhhh');

    // if (
    //   this.tabHdear.name == this.$t("header.home")
    // ) {
    //   const parentLine = document.querySelector(
    //     ".nav-item:nth-child(1) .nav-line"
    //   );
    //   console.log(parentLine, '0000000000000');
    //   parentLine.style.width = "50%"
    // } else {
    //   const parentLine = document.querySelector(
    //     ".nav-item:nth-child(1) .nav-line"
    //   );
    //   console.log(parentLine, 'sgdajksdgasjkdgajks');
    //   parentLine.style.width = "0"
    // }
  },
  watch: {
    topUp(newValue, oldValue) {
      // 等新值大于100的时候再做变化（优化一下）
      if (newValue > 100) {
        if (newValue > oldValue) {
          this.navShow = false;
        } else {
          this.navShow = true;
          this.color = "#333";
          this.border = "1px solid rgba(153, 153, 153, 0.50)";
          this.backgroundLine = "#333";
          this.background = "#fff";
          // this.backdropFilter = "saturate(180%) blur(20px)";
          this.hover = "#333";
          this.logoFalse = false;
        }
      }
      if (newValue == 0) {
        if (newValue < oldValue) {
          this.logoFalse = true;
          this.background = "rgba(0,0,0,0)";
          this.navShow = true;
          this.color = "#fff";
          this.border = "1px solid rgba(255, 255, 255, 0.5)";
          this.backgroundLine = "#fff";
          this.hover = "#333";
        }
      }
    },
  },
  methods: {
    changeLang(lang) {
      let langTetx = lang;
      // let langTetx = lang === "CN" ? "EN" : "CN";
      console.log(langTetx, "langTetx");
      localStorage.setItem("lang", langTetx);
      this.$i18n.locale = langTetx;
      
      const currentRoute = this.$route;
      if (currentRoute.params && currentRoute.params.lang) {
        // 更新路由参数中的语言
        this.$router.replace({
          ...currentRoute,
          params: {
            ...currentRoute.params,
            lang: langTetx.toLowerCase()
          }
        });

      }
      // 如果当前路由没有语言参数，则刷新页面让路由守卫处理
      window.location.reload();
    },
    // 接受子组件数据
    getIndexDataList() {
      getIndexData({}).then((res) => {
        console.log(res);

        this.vocatabList = res.data.business.map((item) => {
          return {
            ...item,
            idName: `idName${item.id}`,
          };
        });
      });
    },
    changeRoute(item) {
      if (/^https?:\/\//.test(item.path)) {
        window.open(item.path, "_blank", "noopener,noreferrer");
        return;
      }
      this.$router.push({
        path: item.path,
        params: {
          lang: this.$i18n.locale.toLowerCase()
        }
      });
    },
    logoLink() {
      this.$router.push({
        path: '/secondLevel/HomeView',
        params: {
          lang: this.$i18n.locale.toLowerCase()
        }
      });
    },
    handleMouseEnter(index) {
      this.vocationFalse = index;
      console.log(index);
      this.background = "#fff";
      this.color = "#333";
      this.backgroundLine = "#333";
      this.border = "1px solid rgba(153, 153, 153, 0.50) ";
      this.logoFalse = false;
      if (this.topUp == 0) {
        if (index == 1) {
          this.background = "#fff";
          this.color = "#333";
          this.backgroundLine = "#333";
          this.border = "1px solid rgba(153, 153, 153, 0.50) ";
          this.logoFalse = false;
        } else {
          this.background = "rgba(0,0,0,0)";
          this.color = "#fff";
          this.backgroundLine = "#fff";
          this.border = "1px solid rgba(255, 255, 255, 0.5)";
          this.logoFalse = true;
        }
      }
    },
    handleMouseLeave() {
      this.vocationFalse = false;
      this.background = "rgba(0,0,0,0)";
      this.color = "#fff";
      this.backgroundLine = "#fff";
      this.border = "1px solid rgba(255, 255, 255, 0.5)";
      this.logoFalse = true;
    },
    handleMouseLeaveone() {
      this.background = "#fff";
      this.color = "#333";
      this.backgroundLine = "#333";
      this.border = "1px solid rgba(153, 153, 153, 0.50) ";
      this.logoFalse = false;
      if (this.topUp == 0) {
        this.background = "rgba(0,0,0,0)";
        this.color = "#fff";
        this.backgroundLine = "#fff";
        this.border = "1px solid rgba(255, 255, 255, 0.5)";
        this.logoFalse = true;
      }
    },
    vocatabClick(it, item) {
      if (this.$route.path.includes(item.path)) {
        this.nameScero = it.idName;
        this.$router.push({
          query: {
            id: it.id,
          },
        });
      } else {
        this.$router.push({
          path: item.path,
          params: {
            lang: this.$i18n.locale.toLowerCase()
          },
          query: item.query
        });
        window.sessionStorage.setItem("anchorPoint", it.idName);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.navOn {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: all 0.2s ease-in-out 0.2s;
  transform: translateZ(0);
  background: #fff;
}

.navOff {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  transition: all 0.2s ease-in-out 0.2s;
  transform: translate3d(0, -100%, 0);
}

.header-box {
  width: 100%;
  height: 100px;
  padding: 0 100px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  // background:rgba(0, 0, 0, 0);
  z-index: 1000;
  transition: all 0.3s;

  .left-logo {
    width: 144px;
    background-size: 100%;
    background-repeat: no-repeat;
    cursor: pointer;

    img {
      width: 100%;
    }
  }

  .content-nav {
    display: flex;
    gap: 100px;

    .active {
      .nav-line {
        width: 50%;
        height: 2px;
        background: #fff;
        margin: 10px auto 0;
        transition: all 0.5s ease-in-out;
      }
    }

    .nav-item {
      font-weight: 700;
      font-size: 20px;
      color: #fff;
      cursor: pointer;
    }

    .nav-line {
      width: 0;
      height: 2px;
      background: #fff;
      margin: 10px auto 0;
      transition: all 0.5s ease-in-out;
    }

    .nav-item:hover .nav-line {
      width: 50%;
      margin: 10px auto 0;
    }
  }

  .content-ennaav {
    gap: 67px;

    .vocationalShow {
      padding: 28px 0 32px 542px;
    }

    .collegeShow {
      padding: 28px 0 32px 970px;
    }

    .nav-item {
      font-size: clamp(16px, 1.1805555556vw, 1.1805555556vw);
    }
  }

  .right-search {
    color: #fff;
    font-size: 16px;
    font-weight: 400;
    padding: 5px 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
    margin-top: -10px;
    height: 16px;
    .language-box {
      display: flex;
      align-items: center;
      gap: 4px;
    }
    .language-icon {
      width: 26px;
      height: 26px;
      outline: none;
      border: none;
      transition: all 0.3s; // 添加过渡效果
    }

    ::v-deep .el-dropdown {
      color: #fff;
    }

    .el-dropdown-link {
      padding: 5px 14px;
      border: 1px solid rgba(255, 255, 255, 0.5);
    }
  }
}

.vocationalShow,
.collegeShow {
  position: absolute;
  left: 0;
  top: 100px;
  background: rgba(255, 255, 255, 0.75);
  width: 100%;
  padding: 28px 0 32px 559px;
  box-sizing: border-box;
  display: flex;
  gap: 60px;
  transition: all 0.3s;

  .vocationalTab,
  .collegeTab {
    color: #000;
    font-size: 16px;
    font-weight: 400;

    .vocaline {
      width: 0;
      height: 2px;
      margin: 10px auto 0;
      background: #fff;
      transition: all 0.5s ease-in-out;
    }
  }

  .vocationalTab:hover,
  .collegeTab:hover {
    .vocaline {
      width: 50%;
      margin: 10px auto 0;
    }
  }
}

.collegeShow {
  padding: 28px 0 32px 979px;
}

.nav-dropdown-item {
  color: #000;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;

  .vocaline {
    width: 0;
    height: 2px;
    margin: 10px auto 0;
    background: #fff;
    transition: all 0.5s ease-in-out;
  }

  &:hover {
    .vocaline {
      width: 50%;
      margin: 10px auto 0;
    }
  }
}

// 添加日文字体大小控制
.jp-text {
  font-size: 16px;
  line-height: 1;
}
</style>
